import {Action} from '@ngrx/store';
import {Transporter} from '../models/transporter';
import {type} from '../utilities/type';

export const transportersActionTypes = {
  LOAD: type('[Transporters] Load'),
  LOAD_SUCCESS: type('[Transporters] Load Success'),
  LOAD_FAIL: type('[Transporters] Load Server Error')
};

export class LoadTransportersAction implements Action {
  readonly type = transportersActionTypes.LOAD;
  constructor() {}
}

export class LoadTransportersSuccessAction implements Action {
  readonly type = transportersActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Transporter[]) {}
}

export class LoadTransportersFailAction implements Action {
  readonly type = transportersActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
